/* eslint-disable react/no-deprecated */
import cx from 'clsx';
import { equals } from 'ramda';
import * as React from 'react';
import { createPortal } from 'react-dom';

import { CloseIcon } from './icons';
import * as styles from './index.css';

export interface ITopPopupOwnProps {
  children: string | React.JSX.Element;
  isError?: boolean;
}

export interface ITopPopupDispatchProps {
  toggleTopPopup(isOpened: boolean): () => void;
}

type ITopPopupProps = ITopPopupOwnProps & ITopPopupDispatchProps;

export class TopPopup extends React.PureComponent<ITopPopupProps, {}> {
  private timeoutId: number;

  public componentDidMount() {
    this.timeoutId = window.setTimeout(this.props.toggleTopPopup(false), 5000);
  }

  public componentDidUpdate(prevProps: ITopPopupProps) {
    if (!equals(prevProps.children, this.props.children)) {
      clearTimeout(this.timeoutId);
      this.timeoutId = window.setTimeout(this.props.toggleTopPopup(false), 5000);
    }
  }

  public componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  public render() {
    const { isError, toggleTopPopup } = this.props;

    return createPortal(
      <div data-name="TopPopup" className={cx(styles['top-popup'], isError && styles['error'])}>
        <div className={styles['close-outer']} onClick={toggleTopPopup(false)}>
          <CloseIcon />
        </div>
        <span>{this.props.children}</span>
      </div>,
      document.body,
    );
  }
}
